import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import styles from "./AddFirstPresentation.module.scss";
import { AddFirstPresentationItem } from "./AddFirstPresentationItem";
import { ITEMS } from "./constants";

export const AddFirstPresentation = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.addFirstSlide}>
            <p className={styles.addFirstSlideTitle}>{t("presentations.createTitle")}</p>
            {ITEMS.map((item) => (
                <AddFirstPresentationItem
                    key={item.src}
                    src={`${canv.host}${item.src}`}
                    text={t(item.textKey)}
                />
            ))}
        </div>
    );
};
